import React from 'react';


const Experience = (props) => {
    return (

        // <!-- Experience-->

        <div className="d-flex flex-column flex-md-row justify-content-between mb-5">
            <div className="flex-grow-1">
                <h3 className="mb-0">{props.titleJob}</h3>
                <div className="subheading mb-3">{props.nameCompany}</div>
                <p>{props.children}</p>
            </div>
            <div className="flex-shrink-0"><span className="text-primary">{props.date}</span></div>
        </div>



    );
};

export default Experience;